module.exports = __webpack_public_path__ + "static/adset-builder-696e31945ca4f33dbcd88291b3aeecdd.svg";